import React from 'react';

export default function FloatingShapes() {
  const shapes = [
    { type: 'circle', size: 60, color: '#81c78460', top: '10%', left: '5%', duration: 20 },
    { type: 'circle', size: 40, color: '#64b5f660', top: '70%', left: '90%', duration: 25 },
    { type: 'square', size: 50, color: '#fdd83560', top: '30%', left: '85%', duration: 30 },
    { type: 'circle', size: 80, color: '#81c78460', top: '85%', left: '10%', duration: 35 },
    { type: 'square', size: 35, color: '#64b5f660', top: '50%', left: '95%', duration: 22 },
    { type: 'circle', size: 45, color: '#fdd83560', top: '15%', left: '50%', duration: 28 },
    { type: 'square', size: 55, color: '#81c78460', top: '60%', left: '15%', duration: 32 },
    { type: 'circle', size: 70, color: '#64b5f660', top: '40%', left: '8%', duration: 26 },
  ];

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      zIndex: 0,
      overflow: 'hidden'
    }}>
      {shapes.map((shape, index) => (
        <div
          key={index}
          style={{
            position: 'absolute',
            top: shape.top,
            left: shape.left,
            width: `${shape.size}px`,
            height: `${shape.size}px`,
            background: shape.color,
            borderRadius: shape.type === 'circle' ? '50%' : '12px',
            animation: `float ${shape.duration}s ease-in-out infinite`,
            opacity: 0.6
          }}
        />
      ))}
      
      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px) rotate(0deg);
          }
          25% {
            transform: translateY(-20px) rotate(5deg);
          }
          50% {
            transform: translateY(0px) rotate(0deg);
          }
          75% {
            transform: translateY(20px) rotate(-5deg);
          }
        }
      `}</style>
    </div>
  );
}